type Props = {
  color?: string,
} & typeof defaultProps;

const defaultProps = {
  color: '#7E7E7E',
};
const SelectIcon = function SelectIcon(props: Props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M12.5155 15.6932H3.03759C1.47218 15.6932 0.198486 14.4195 0.198486 12.8541V3.37621C0.198486 1.81081 1.47218 0.537109 3.03759 0.537109H11.8931C12.4143 0.537109 12.8361 0.958951 12.8361 1.48012C12.8361 2.00067 12.4143 2.42314 11.8931 2.42314H3.03759C2.51202 2.42314 2.08452 2.85064 2.08452 3.37621V12.8541C2.08452 13.3797 2.51202 13.8072 3.03759 13.8072H12.5161C13.0411 13.8072 13.468 13.3797 13.468 12.8541V7.55377C13.468 7.03322 13.8898 6.61075 14.411 6.61075C14.9321 6.61075 15.354 7.03322 15.354 7.55377V12.8541C15.3534 14.4195 14.0809 15.6932 12.5155 15.6932Z" fill={color} />
      <path d="M7.38049 11.229C7.13028 11.2284 6.88949 11.129 6.71284 10.9517L3.73794 7.96489C3.37016 7.59586 3.37142 6.99862 3.74045 6.63147C4.10886 6.26306 4.70673 6.26432 5.07388 6.63398L7.38238 8.95128L15.1914 1.14227C15.5598 0.773866 16.1564 0.773866 16.5248 1.14227C16.8932 1.51067 16.8932 2.10792 16.5248 2.47569L8.04752 10.953C7.87086 11.1296 7.6307 11.229 7.38049 11.229Z" fill={color} />
    </svg>
  );
};
SelectIcon.defaultProps = defaultProps;
export default SelectIcon;
